<template>
    <RPBaseCard
        class="InfoCard"
        :title="title"
        :subtitle="subtitle"
        :status="status"
    >
        <template v-slot:leadingIcon>
            <slot name="leadingIcon"></slot>
        </template>
        <!-- @slot Can be used in place of the `title` prop -->
        <template v-slot:title>
            <slot name="title"></slot>
        </template>
        <!-- @slot Can be used in place of the `subtitle` prop -->
        <template v-slot:subtitle>
            <slot name="subtitle"></slot>
        </template>
        <div class="InfoCard__information">
            <!-- @slot Can be used in place of the `info` prop -->
            <slot name="information">
                {{ info }}
            </slot>
        </div>
    </RPBaseCard>
</template>
<script>
import RPBaseCard from './RPBaseCard.vue';
import stat from 'status/index';
export default {
    name: 'RPInfoCard',
    components: {
        RPBaseCard,
    },
    props: {
        title: {
            type: String,
            default: '',
        },
        subtitle: {
            type: String,
            default: '',
        },
        info: {
            type: String,
            default: '',
        },
        status: {
            type: String,
            default: stat.STANDBY
        },
    },
};
</script>
<style lang="scss">
    .InfoCard {
        display: inline-flex;
        justify-content: space-between;

        &__title-container {
           display: flex;
            flex-direction: column;
        }
        &__title {
            font-weight: 600;
        }
        &__subtitle{
            color: $grey
        }
        &__information {
            margin: auto 0;
        }
    }
</style>

<docs>
```vue
<RPInfoCard
    title="Information Card"
    subtitle="Has Some Info"
    info="Quisque vel facilisis arcu amet et tristique adipiscing convallis dis ad hendrerit, nostra quis class consequat tincidunt cum dui magna nascetur nullam feugiat"
/>

<p>Using slots:</p>

<RPInfoCard>
    <template v-slot:title>
        <h2>Information Card</h2>
    </template>
    <template v-slot:subtitle>
        <p>Has Some Info</p>
    </template>
    <template v-slot:information>
        <p>Quisque vel facilisis arcu amet et tristique adipiscing convallis dis ad hendrerit, nostra quis class consequat tincidunt cum dui magna nascetur nullam feugiat</p>
    </template>
</RPInfoCard>
```
</docs>
